import { createLogger } from 'redux-logger';

const logger = createLogger({
  collapsed: true,
  duration: true,
  timestamp: false,
  colors: {
    title: (action) => {
      if (action.type.includes('fulfilled')) {
        return 'green';
      }
      if (action.type.includes('rejected')) {
        return 'red';
      }

      return '#8282f3';
    },
    prevState: () => {
      return 'gray';
    },
    action: () => {
      return 'blue';
    },
    nextState: () => {
      return 'gray';
    },
  },
});

export default logger;
